import React from 'react';
import createRoutes from './routes';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import AppContainer from './AppContainer';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;

const App = () => {
  const { store, persistor } = configureStore();

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppContainer>{createRoutes()}</AppContainer>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
